export default __webpack_public_path__ + "static/hochzeitsfotos-berlin-brandenburg-panketal-claudia_nuernberger-2c8b68d7d1a339ae2c426dae179407e6.jpg";